import Select from "antd/lib/select";
const Option = Select.Option;
import { getCurrentLang } from "../libs/lang";

import { translate } from "react-i18next";

class Switch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      token: null,
      language: ""
    };
  }

  componentDidMount() {
    this.setState({
      language: this.getCookie("i18next")
    })
  }

  // getCookie = (cname) => {
  //   var name = cname + "=";
  //   var decodedCookie = decodeURIComponent(document.cookie);
  //   var ca = decodedCookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") {
  //       c = c.substring(1);
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length);
  //     }
  //   }
  //   return "";
  // };

  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    if(ca.length>0){
      var c = ca[0];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    else
      return ""
  };

  handleChange = (value) => {
    this.deleteCookie("i18next")
    document.cookie = `i18next=${value};`
    window.location.href = window.location.pathname + document.location.search
    this.setState({
      language : value
    })
  };

  deleteCookie = (named)=>{
    document.cookie = named + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  render() {
    const { t } = this.props;
    return (
      <Select
        className="switcher"
        value={this.state.language}
        onChange={this.handleChange}
      >
        <Option value="th-TH">{t("language.th")}</Option>
        <Option value="en-US">{t("language.en")}</Option> 
      </Select>
    );
  }
}

export default translate()(Switch);
